export default {
    API_URL: "https://api-eficience.infinitum-ti.com/api",
    FILE_URL: "https://api-eficience.infinitum-ti.com/file",
    OAPI_URL: "https://api-eficience.infinitum-ti.com/oapi",
    ARQUIVOS_URL: "https://arquivo.gradios.com.br",
    // API_URL: "http://localhost:2385/api",
    // FILE_URL: "http://localhost:2385/file",
    // OAPI_URL: "http://localhost:2385/oapi",
    // ARQUIVOS_URL: "http://localhost:2385",
    // API_URL: "http://192.168.2.130:2385/api",
    // FILE_URL: "http://192.168.2.130:2385/file",
    // OAPI_URL: "http://192.168.2.130:2385/oapi",
    // ARQUIVOS_URL: "http://192.168.2.130:2376",
    ANO_INICIO_MONITORAMENTO_SOLAR: 2023
};
